/**
 * Check if provided argument is a function
 * @param {*} functionToCheck - The argument to check
 */
export function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get cookie value by name
 * @param {string} name - key name
 */
export function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
}

export function getCookieValue(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(";");

    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === " ") {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}

export function setRefreshTokenCookie(value, expiresIn, key) {
    // Calculate the expiration time
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + expiresIn * 1000); // in milliseconds

    // Check if refreshToken cookie exists
    const existingRefreshToken = getCookieValue(key);

    if (existingRefreshToken) {
        // Remove existing refreshToken cookie by setting its expiration date to a past time
        document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
    // Set the new refreshToken cookie
    document.cookie = `${key}=${value}; expires=${expirationDate.toUTCString()}; path=/;`;
}
